// Scroll reveal
(function () {
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (x) {
      if (x.isIntersecting) { x.target.classList.add('in'); obs.unobserve(x.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
  document.querySelectorAll('.reveal').forEach(function (el) { obs.observe(el); });
})();

// Hero entrance animation
document.querySelectorAll('.hero__eyebrow, .hero__title, .hero__sub, .hero__cta-row').forEach(function (el, i) {
  el.style.cssText = 'opacity:0;transform:translateY(20px);transition:opacity .9s ease,transform .9s ease';
  setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'translateY(0)'; }, 400 + i * 160);
});

// Search overlay
window.openSearch = function () {
  var overlay = document.getElementById('searchOverlay');
  if (overlay) {
    overlay.classList.add('active');
    setTimeout(function () { var inp = document.getElementById('searchInput'); if (inp) inp.focus(); }, 100);
  }
};
window.closeSearch = function () {
  var overlay = document.getElementById('searchOverlay');
  if (overlay) overlay.classList.remove('active');
};
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.closeSearch(); });
(function () {
  var overlay = document.getElementById('searchOverlay');
  if (overlay) {
    overlay.addEventListener('click', function (e) { if (e.target === this) window.closeSearch(); });
  }
  function doSearch() {
    var inp = document.getElementById('searchInput');
    var q = inp && inp.value.trim();
    if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
  }
  var inp = document.getElementById('searchInput');
  if (inp) {
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doSearch(); } });
  }
  var searchBtn = document.querySelector('#searchOverlay .search-wrap button');
  if (searchBtn) searchBtn.addEventListener('click', doSearch);
})();

// Language toggle
var _bcT = {
  en: {
    'hero-sub':    'Authentic industrial lighting sourced from film studios, factories, theatres and hospitals. Every piece is unique. Every piece is irreplaceable.',
    'cta-explore': 'Explore the Collection',
    'cta-story':   'Our Story'
  },
  nl: {
    'hero-sub':    "Authentieke industriële verlichting afkomstig van filmstudio's, fabrieken, theaters en ziekenhuizen. Elk stuk is uniek. Elk stuk is onvervangbaar.",
    'cta-explore': 'Bekijk de Collectie',
    'cta-story':   'Ons Verhaal'
  }
};
window.setLang = function (lang) {
  var btnEN = document.getElementById('langEN');
  var btnNL = document.getElementById('langNL');
  if (btnEN) btnEN.classList.toggle('active', lang === 'en');
  if (btnNL) btnNL.classList.toggle('active', lang === 'nl');
  var t = _bcT[lang] || {};
  var ids = Object.keys(t).concat(['hero-sub', 'cta-explore', 'cta-story']);
  ids.filter(function (v, i, a) { return a.indexOf(v) === i; }).forEach(function (id) {
    var el = document.getElementById(id); if (!el) return;
    var val = (el.dataset && el.dataset[lang]) ? el.dataset[lang] : t[id];
    if (val) el.textContent = val;
  });
  document.querySelectorAll('.t-txt').forEach(function (el) {
    el.textContent = el.dataset[lang] || el.dataset.en || '';
  });
};

// Apply saved language preference after this script loads (deferred)
try {
  if (localStorage.getItem('bc-lang') === 'nl') setLang('nl');
} catch (e) {}
